import { Link } from "react-router-dom";
import { hotSearches, siteStats } from "@/mocks/gossip";

const marqueeItems = hotSearches.map((item) => item.title);

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden bg-primary-950">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20of%20a%20lush%20green%20melon%20vine%20field%20at%20golden%20hour%20with%20floating%20chat%20bubbles%2C%20deep%20emerald%20green%20and%20warm%20amber%20tones%2C%20modern%20editorial%20magazine%20cover%20style%2C%20soft%20grain%20texture%2C%20dreamy%20bokeh%2C%20dark%20moody%20edges%20for%20text%20contrast%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=gt-hero-main&orientation=landscape"
        alt="瓜田藤蔓与气泡交织的艺术插画，象征吃瓜群众围观现场"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/80 via-primary-950/65 to-primary-950/85"></div>

      <div className="relative mx-auto w-full max-w-7xl px-4 py-14 md:px-8 md:py-24">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div className="gt-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-3.5 py-1.5 text-xs font-medium text-background-100 backdrop-blur">
              <i className="ri-live-line text-sm text-secondary-300" aria-hidden="true"></i>
              吃瓜群众集合地 · 24 小时滚动更新
            </span>
            <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
              瓜田吃瓜
              <span className="mt-3 block text-xl font-bold text-secondary-300 md:text-3xl">
                围观现场，蹲后续不迷路
              </span>
            </h1>
            <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
              娱乐八卦、影视综艺、社会热点、音乐潮流，我们把散落各处的公开信息按时间线拼起来。反转与实锤反复补全，前排围观站队之前，先把事情看清楚。
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/plaza"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
              >
                <i className="ri-fire-line text-base" aria-hidden="true"></i>
                进入瓜田广场
              </Link>
              <Link
                to="/#follow"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-notification-3-line text-base" aria-hidden="true"></i>
                订阅蹲后续
              </Link>
            </div>

            <dl className="mt-10 grid grid-cols-2 gap-4 border-t border-background-50/20 pt-6 sm:grid-cols-4">
              {siteStats.map((stat) => (
                <div key={stat.id}>
                  <dt className="text-xs text-background-200">{stat.label}</dt>
                  <dd className="mt-1 font-heading text-2xl font-bold text-secondary-300">
                    {stat.value}
                    <span className="ml-0.5 text-xs font-medium text-background-200">{stat.unit}</span>
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="gt-fade-up lg:justify-self-end">
            <div className="w-full rounded-lg border border-background-50/20 bg-background-50/10 p-5 backdrop-blur-md md:p-6 lg:max-w-md">
              <div className="flex items-center justify-between">
                <h2 className="font-heading text-lg font-bold text-background-50">此刻正在围观</h2>
                <span className="flex items-center gap-1.5 text-xs text-secondary-300">
                  <span className="h-2 w-2 rounded-full bg-accent-400"></span>
                  实时
                </span>
              </div>
              <ul className="mt-4 space-y-3">
                {hotSearches.slice(0, 4).map((item) => (
                  <li key={item.id} className="flex items-start gap-3">
                    <span
                      className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                        item.rank <= 3
                          ? "bg-accent-500 text-background-50"
                          : "bg-background-50/15 text-background-100"
                      }`}
                    >
                      {item.rank}
                    </span>
                    <div className="min-w-0">
                      <p className="truncate text-sm font-medium text-background-50">{item.title}</p>
                      <p className="mt-0.5 text-xs text-background-300">{item.scopeHint}</p>
                    </div>
                  </li>
                ))}
              </ul>
              <Link
                to="/plaza"
                className="mt-5 inline-flex w-full items-center justify-center gap-1 whitespace-nowrap rounded-md border border-background-50/30 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                看完整热搜榜
                <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="relative w-full overflow-hidden border-t border-background-50/15 bg-accent-500 py-2.5">
        <div className="gt-marquee flex w-max items-center gap-8">
          {[...marqueeItems, ...marqueeItems].map((text, index) => (
            <span
              key={`${text}-${index}`}
              className="flex items-center gap-2 whitespace-nowrap text-xs font-medium text-background-50 md:text-sm"
            >
              <i className="ri-flashlight-fill text-secondary-200" aria-hidden="true"></i>
              {text}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}